import { Model } from "./model";
import { BrandLogo } from "./brand-logo.model";
import { BrandCountryLanguage } from "./brand-country-language.model";

export class Brand extends Model {
    id: number;
    name: string;
    logo: string;
    white_logo: string;
    brand_logo_url: string;
    brand_white_logo_url: string;
    content: BrandCountryLanguage;
    logos?: BrandLogo;
}



// WEBPACK FOOTER //
// ./src/models/brand.model.ts